import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const ReportsTab = () => {
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchReport = async () => {
      setLoading(true);
      const token = localStorage.getItem('token');
      const res = await fetch('/api/coo/reports', {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await res.json();
      setReportData(data.stageBreakdown || []);
      setLoading(false);
    };
    fetchReport();
  }, []);

  const exportCSV = () => {
    const headers = ['Stage', 'Total Tasks', 'Completed', 'Pending', 'Overdue', 'Performance'];
    const rows = reportData.map(row => [row.stage, row.total, row.completed, row.pending, row.overdue, row.performance]);
    let csv = headers.join(',') + '\n';
    rows.forEach(r => { csv += r.join(',') + '\n'; });
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'stage_report.csv';
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="p-4">
      {/* Breadcrumbs and Back */}
      <div className="mb-4 flex items-center text-sm text-gray-500">
        <button onClick={() => navigate('/coo-dashboard')} className="mr-2 px-2 py-1 bg-gray-200 rounded hover:bg-gray-300">← Back</button>
        <Link to="/coo-dashboard" className="hover:underline text-wtf-red">Home</Link>
        <span className="mx-2">/</span>
        <span>Reports</span>
      </div>
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold">Stage-wise Task Breakdown</h2>
        <button onClick={exportCSV} className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">Export CSV</button>
      </div>
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border rounded">
          <thead>
            <tr>
              <th className="px-4 py-2 border">Stage</th>
              <th className="px-4 py-2 border">Total Tasks</th>
              <th className="px-4 py-2 border">Completed</th>
              <th className="px-4 py-2 border">Pending</th>
              <th className="px-4 py-2 border">Overdue</th>
              <th className="px-4 py-2 border">Performance</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={6} className="text-center py-8">Loading...</td></tr>
            ) : reportData.length === 0 ? (
              <tr><td colSpan={6} className="text-center py-8">No data found.</td></tr>
            ) : (
              reportData.map((row, idx) => (
                <tr key={idx} className="border-b">
                  <td className="px-4 py-2 border">{row.stage}</td>
                  <td className="px-4 py-2 border">{row.total}</td>
                  <td className="px-4 py-2 border">{row.completed}</td>
                  <td className="px-4 py-2 border">{row.pending}</td>
                  <td className="px-4 py-2 border">{row.overdue}</td>
                  <td className="px-4 py-2 border">{row.performance}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ReportsTab; 